
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_connect/u",
      function () {
        return require("private-next-pages/blockquiry_connect/u/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blockquiry_connect/u"])
      });
    }
  